export const ERROR_CODES = {
  paperwork_dob_appointment_unavailable:
    'paperwork.error.appointmentUnavailable',
  paperwork_dob_verification_failed: 'paperwork.error.verifyDob.invalidDob',
};



// WEBPACK FOOTER //
// ./src/components/Paperwork/components/JoinForm/helpers/index.js